import Flickity from 'flickity';

export default {
  init($element) {

  },
  finalize($element) {
    // const testimonialDuration = 10000; // Duration in ms
    // var currentProgress = 0;
    // var currentSlide = 0;
    // var totalSlides = $element.find('.testimonial').length;

    // function changeSlide(index) {
    //   // Go to next slide
    //   const $currentGoto = $element.find(`.testimonial-goto[data-testimonial-index="${currentSlide}"]`);
    //   const $currentTestimonial = $element.find(`.testimonial[data-testimonial-index="${currentSlide}"]`);

    //   $currentGoto.find('.fill').css({ 'transform': 'rotate(0)' });
    //   $currentGoto.removeClass('active');
    //   $currentTestimonial.addClass('hiding');

    //   setTimeout(() => {
    //     $currentTestimonial.removeClass('show hiding');
    //   }, 250);

    //   currentSlide = index;

    //   if (currentSlide >= totalSlides) {
    //     currentSlide = 0;
    //   }

    //   const $nextGoto = $element.find(`.testimonial-goto[data-testimonial-index="${currentSlide}"]`);
    //   const $nextTestimonial = $element.find(`.testimonial[data-testimonial-index="${currentSlide}"]`);

    //   $nextGoto.addClass('active');
    //   $nextTestimonial.addClass('show');
    // }

    /*setInterval(() => {
      if (totalSlides > 1) {
        currentProgress += 50;

        if (currentProgress >= testimonialDuration) {
          currentProgress = 0;

          changeSlide(currentSlide + 1);
        }

        const $currentGoto = $element.find('.testimonial-goto.active');

        if (currentProgress < (testimonialDuration / 2)) {
          // Less than halfway
          const amount = 180 / ((testimonialDuration / 2) / currentProgress);
          $currentGoto.find('.hold.hold-top .fill').css({transform: `rotate(${amount}deg)`});
        } else {
          // Snap to correct amount
          $currentGoto.find('.hold.hold-top .fill').css({transform: 'rotate(180deg)'});

          // More than halfway
          const amount = 180 / ((testimonialDuration / 2) / (currentProgress - (testimonialDuration / 2)));
          $currentGoto.find('.hold.hold-bottom .fill').css({transform: `rotate(${amount}deg)`});
        }
      }

    }, 50);

    $element.find('.testimonial-goto').on('click', function() {
      if ($(this).data('testimonial-index') != currentSlide) {
        currentProgress = 0;
        changeSlide($(this).data('testimonial-index'));
      }
    });*/

    const testimonialsCarousel = new Flickity($element.find('.testimonial-wrap').get()[0], {
      // adaptiveHeight: true,
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      contain: true,
      wrapAround: true,
      on: {
        ready: function() {
          window.dispatchEvent(new Event('resize')); // Quickfix for sizing issue
        },
      },
    });

    $element.find('.testimonial-goto-prev').on('click', function() {
      testimonialsCarousel.previous();
    });

    $element.find('.testimonial-goto-next').on('click', function() {
      testimonialsCarousel.next();
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/partials/shared/testimonials.js